@if (clients$ | async; as clients) {
  <p-floatlabel variant="in">
    <p-multiSelect
      [options]="clients"
      [(ngModel)]="selectedItem"
      (ngModelChange)="onSelectedChange($event)"
      optionLabel="user.fullname"
      display="chip"
      scrollHeight="250px"
      appendTo="self"
      [maxSelectedLabels]="10"
      [filter]="true"
      [style]="{ width: '100%', border: 'none' }"
      class="ms-overlay"
    ></p-multiSelect>
    <label>
      {{ 'EVENT_EDITOR.CLIENT' | transloco }}
      <ion-text color="danger">&nbsp;*</ion-text>
    </label>
  </p-floatlabel>
}
